import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { NGroups } from '../interfaces/services/groups.interfaces'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { sortStringsAlphabetically } from '../helpers/sorting'

export const getGroupsPerSociety = (
  societyId: string
): Promise<AxiosResponse<NGroups.NGetPerSocieties.IResponse>> => {
  const body: NGroups.NGetPerSocieties.IRequestBody = {
    societyIds: [societyId],
  }
  return axiosAuth.post<NGroups.NGetPerSocieties.IResponse>(
    createUrl('/groups/get-per-societies/'),
    body
  )
}

export const createGroup = (
  body: NGroups.NCreate.IRequestBody
): Promise<AxiosResponse<NGroups.NCreate.IResponse>> => {
  return axiosAuth.post<NGroups.NCreate.IResponse>(
    createUrl(`/groups/group`),
    body
  )
}

export const getGroup = (
  id: string
): Promise<AxiosResponse<NGroups.NGetById.IResponse>> => {
  return axiosAuth.get<NGroups.NGetById.IResponse>(
    createUrl(`/groups/group/${id}`)
  )
}

export const deleteGroup = (
  id: string
): Promise<AxiosResponse<NGroups.NDel.IResponse>> => {
  return axiosAuth.delete<NGroups.NDel.IResponse>(
    createUrl(`/groups/group/${id}`)
  )
}

export const patchGroup = (variables: {
  id: string
  body: NGroups.NPatch.IRequestBody
}): Promise<AxiosResponse<NGroups.NPatch.IResponse>> => {
  return axiosAuth.patch<NGroups.NPatch.IResponse>(
    createUrl(`/groups/group/${variables.id}`),
    variables.body
  )
}

export const groupQueries = {
  getGroupsPerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'group', entity: 'list', societyId }],
      queryFn: async ({ queryKey }) => {
        const groups = (await getGroupsPerSociety(queryKey[0].societyId!)).data
          .data
        groups.sort((a, b) => sortStringsAlphabetically(a.name, b.name))
        return groups
      },
      enabled: !!societyId,
    }),
  getGroup: (groupId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'group', entity: 'detail', groupId }],
      queryFn: async ({ queryKey }) => {
        return (await getGroup(queryKey[0].groupId!)).data.data
      },
      enabled: !!groupId,
    }),
}
